import { FC } from 'react'
import { CoberturaEspeciaisTemas } from '../interfaces'
import {
    CoberturaCardRoot,
    CoberturaCardContent,
    CoberturaCardTitle,
    CoberturaCardDescription,
    CoberturaCardCompanyRoot,
    CoberturaCardSmall,
    CoberturaCardLogo
} from '../style/coberturas-especiais.style'
import Image from 'next/image'
import { relationQuote, SponsorType } from '@App/libs/utils/geral'

const getURLPath = (link: URL) => {
    try {
        if (typeof window !== 'undefined') {
            return new URL(link).pathname
        } else {
            const baseUrl =
                process.env.NEXT_PUBLIC_SITE_URL ?? 'http://localhost'
            return new URL(link, baseUrl).pathname
        }
    } catch {
        return '#'
    }
}

export const CoberturaCard: FC<CoberturaEspeciaisTemas> = ({
    background_image: backgroundImage,
    company_logo: companyLogo,
    company_name: companyName,
    description,
    relation_type: relationType,
    link,
    name
}) => {
    const url = new URL(link)

    return (
        <CoberturaCardRoot
            href={getURLPath(url)}
            target='_self'
            className='card-coberturas-especiais'
        >
            {backgroundImage && (
                <Image
                    src={backgroundImage}
                    alt={companyName ?? name}
                    width={600}
                    height={600}
                    quality={100}
                    style={{
                        borderRadius: '4px 4px 0 0',
                        objectFit: 'contain',
                        width: '100%',
                        height: 'auto'
                    }}
                />
            )}
            <CoberturaCardContent>
                <div>
                    <CoberturaCardTitle>{name}</CoberturaCardTitle>
                    <CoberturaCardDescription>
                        {description}
                    </CoberturaCardDescription>
                </div>
                <CoberturaCardCompanyRoot>
                    {relationType && (
                        <CoberturaCardSmall>
                            {relationQuote(relationType as SponsorType)}
                        </CoberturaCardSmall>
                    )}
                    <CoberturaCardLogo>
                        {companyLogo && (
                            <Image
                                src={companyLogo}
                                width={80}
                                height={80}
                                alt={`${companyName} logo`}
                            />
                        )}
                    </CoberturaCardLogo>
                </CoberturaCardCompanyRoot>
            </CoberturaCardContent>
        </CoberturaCardRoot>
    )
}
